var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClassSchedules(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.095,
    height: 20.72,
    viewBox: "0 0 19.095 20.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier",
    transform: "translate(-2.14 0.36)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2762",
    "data-name": "Group 2762",
    transform: "translate(2.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4822",
    "data-name": "Path 4822",
    d: "M40.729,42.116l-1.99-2.081a3.617,3.617,0,1,0-.493.45l2,2.092a.333.333,0,1,0,.482-.461ZM36.08,40.549a2.932,2.932,0,1,1,2.932-2.932A2.935,2.935,0,0,1,36.08,40.549Z",
    transform: "translate(-22.488 -22.679)",
    stroke: "#000",
    strokeWidth: 0.72
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4823",
    "data-name": "Path 4823",
    d: "M16.167,21H9.5v9.667h6.667v-6h6V21h-6ZM12.5,30H10.167V27.667H12.5Zm0-3H10.167V24.667H12.5Zm0-3H10.167V21.667H12.5Zm3,6H13.167V27.667H15.5Zm0-3H13.167V24.667H15.5Zm0-3H13.167V21.667H15.5Zm3,0H16.167V21.667H18.5Zm.667-2.333H21.5V24H19.167Z",
    transform: "translate(-7.167 -14)",
    stroke: "#000",
    strokeWidth: 0.72
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4824",
    "data-name": "Path 4824",
    d: "M12.167,18.333h-9v-13h16V10a.333.333,0,1,0,.667,0V1.667a.333.333,0,0,0-.333-.333H17.833v-1A.333.333,0,0,0,17.5,0H15.167a.333.333,0,0,0-.333.333v1H7.5v-1A.333.333,0,0,0,7.167,0H4.833A.333.333,0,0,0,4.5.333v1H2.833a.333.333,0,0,0-.333.333v17A.333.333,0,0,0,2.833,19h9.333a.333.333,0,0,0,0-.667ZM15.5,1.667v-1h1.667v2H15.5Zm-10.333,0v-1H6.833v2H5.167ZM3.167,2H4.5V3a.333.333,0,0,0,.333.333H7.167A.333.333,0,0,0,7.5,3V2h7.333V3a.333.333,0,0,0,.333.333H17.5A.333.333,0,0,0,17.833,3V2h1.333V4.667h-16Z",
    transform: "translate(-2.5)",
    stroke: "#000",
    strokeWidth: 0.72
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClassSchedules);
export default __webpack_public_path__ + "static/media/ClassSchedules.ae10555122cbf0092446ee5155e7e343.svg";
export { ForwardRef as ReactComponent };